import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ReactNavDots extends Component {
  constructor(props) {
    super(props);

    // init
    this.previousActiveIndex = 0;
    this.onCenterLeft = false;
    this.reachedIndexFour = false;
  }

  render() {
    const { dots, activeDotClassName } = this.props;

    // each dot in dots prop is an LI element with a button child

    // on init activeDots is assigned to the first 5 dots and we give them the classNames also check for active dot
    let activeDots = [];
    const activeDot = dots.find(
      dot => dot.props.className === activeDotClassName
    );
    const activeIndex = parseInt(activeDot.key);
    const isMovingForward = activeIndex > this.previousActiveIndex;

    // check to see total dots is larger than 7
    if (dots.length > 7) {
      activeDots = dots.map((dot, i) => {
        if (dot.props.className === activeDotClassName) {
          return React.cloneElement(dot, {
            className: 'slick-active large',
          }, React.cloneElement(dot.props.children, {disabled: true}));
        } else if (i === 3) {
          return React.cloneElement(dot, {className: 'semi'}, React.cloneElement(dot.props.children, {disabled: true}));
        } else if (i === 4) {
          return React.cloneElement(dot, {
            className: 'small',
          }, React.cloneElement(dot.props.children, {disabled: true}));
        } else if (i < 4) {
          return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
        }

        return React.cloneElement(dot, {
          className: 'none',
        });

      });

      if (isMovingForward) {
        // first we must do the corner cases (first 6 indexes and last ones aswell)
        if (activeIndex === 3) {
          activeDots = dots.map((dot, i) => {
            if (dot.props.className === activeDotClassName) {
              return React.cloneElement(dot, {
                className: 'slick-active large',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === 0 || i === 4) {
              return React.cloneElement(dot, {
                className: 'semi',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === 1 || i === 2) {
              return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === 5) {
              return React.cloneElement(dot, {
                className: 'small',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            }

            return React.cloneElement(dot, {
              className: 'none',
            });

          });
        } else if (activeIndex === 4) {
          this.reachedIndexFour = true;
          this.onCenterLeft = true;
          activeDots = dots.map((dot, i) => {
            if (dot.props.className === activeDotClassName) {
              return React.cloneElement(dot, {
                className: 'slick-active large',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === 0 || i === 6) {
              return React.cloneElement(dot, {
                className: 'small',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === 1 || i === 5) {
              return React.cloneElement(dot, {
                className: 'semi',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === 2 || i === 3) {
              return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
            }

            return React.cloneElement(dot, {
              className: 'none',
            });

          });
        }  else if (activeIndex === dots.length - 1) {
          activeDots = dots.map((dot, i) => {
            if (dot.props.className === activeDotClassName) {
              return React.cloneElement(dot, {
                className: 'slick-active large',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === dots.length - 5) {
              return React.cloneElement(dot, {
                className: 'small',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === dots.length - 4) {
              return React.cloneElement(dot, {
                className: 'semi',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === dots.length - 2 || i === dots.length - 3) {
              return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
            }

            return React.cloneElement(dot, {
              className: 'none',
            });

          });
        } else if (activeIndex > 4) {
          if (this.onCenterLeft === false) {
            this.onCenterLeft = true;
            activeDots = dots.map((dot, i) => {
              if (dot.props.className === activeDotClassName) {
                return React.cloneElement(dot, {
                  className: 'slick-active large',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 1 === i ||
                                activeIndex + 1 === i
              ) {
                return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 2 === i ||
                                activeIndex + 2 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'semi',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 3 === i ||
                                activeIndex + 3 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'small',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              }

              return React.cloneElement(dot, {
                className: 'none',
              });

            });
          } else if (this.onCenterLeft === true) {
            activeDots = dots.map((dot, i) => {
              if (dot.props.className === activeDotClassName) {
                return React.cloneElement(dot, {
                  className: 'slick-active large',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 1 === i ||
                                activeIndex - 2 === i
              ) {
                return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 3 === i ||
                                activeIndex + 1 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'semi',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 4 === i ||
                                activeIndex + 2 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'small',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              }

              return React.cloneElement(dot, {
                className: 'none',
              });

            });
          }
        }
      } else {
        if (activeIndex === dots.length - 2) {
          activeDots = dots.map((dot, i) => {
            if (dot.props.className === activeDotClassName) {
              return React.cloneElement(dot, {
                className: 'slick-active large',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (
              activeIndex + 1 === i ||
                            activeIndex - 1 === i
            ) {
              return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (activeIndex - 2 === i) {
              return React.cloneElement(dot, {
                className: 'semi',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (activeIndex - 3 === i) {
              return React.cloneElement(dot, {
                className: 'small',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            }

            return React.cloneElement(dot, {
              className: 'none',
            });

          });
        } else if (activeIndex === dots.length - 3) {
          activeDots = dots.map((dot, i) => {
            if (dot.props.className === activeDotClassName) {
              return React.cloneElement(dot, {
                className: 'slick-active large',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (
              activeIndex + 1 === i ||
                            activeIndex + 2 === i
            ) {
              return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (activeIndex - 1 === i) {
              return React.cloneElement(dot, {
                className: 'semi',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (activeIndex - 2 === i) {
              return React.cloneElement(dot, {
                className: 'small',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            }

            return React.cloneElement(dot, {
              className: 'none',
            });

          });
        } else if (activeIndex === dots.length - 4) {
          activeDots = dots.map((dot, i) => {
            if (dot.props.className === activeDotClassName) {
              return React.cloneElement(dot, {
                className: 'slick-active large',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (
              activeIndex + 1 === i ||
                            activeIndex + 2 === i
            ) {
              return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (
              activeIndex - 1 === i ||
                            activeIndex + 3 === i
            ) {
              return React.cloneElement(dot, {
                className: 'semi',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (activeIndex - 2 === i) {
              return React.cloneElement(dot, {
                className: 'small',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            }

            return React.cloneElement(dot, {
              className: 'none',
            });

          });
        } else if (activeIndex === 1 && this.previousActiveIndex === 2) {
          // console.log('this is where the error happens');
          // for some reason theres an error that happens here but if we leave this else if empty it doesnt occur
        } else if (activeIndex === 0) {
          // avoid the 4 dot showing up senerio
          activeDots = dots.map((dot, i) => {
            if (dot.props.className === activeDotClassName) {
              return React.cloneElement(dot, {
                className: 'slick-active large',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === 3) {
              return React.cloneElement(dot, {className: 'semi'}, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i === 4) {
              return React.cloneElement(dot, {
                className: 'small',
              }, React.cloneElement(dot.props.children, {disabled: true}));
            } else if (i < 4) {
              return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
            }

            return React.cloneElement(dot, {
              className: 'none',
            });

          });
        } else if (activeIndex === 2 && this.previousActiveIndex === 3) {
          if(this.reachedIndexFour === true) {
            this.reachedIndexFour = false;
            activeDots = dots.map((dot, i) => {
              if (dot.props.className === activeDotClassName) {
                return React.cloneElement(dot, {
                  className: 'slick-active large',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex + 1 === i ||
                                activeIndex + 2 === i
              ) {
                return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 1 === i ||
                                activeIndex + 3 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'semi',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 2 === i ||
                                activeIndex + 4 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'small',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              }

              return React.cloneElement(dot, {
                className: 'none',
              });

            });
          } else {
            activeDots = dots.map((dot, i) => {
              if (dot.props.className === activeDotClassName) {
                return React.cloneElement(dot, {
                  className: 'slick-active large',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 1 === i ||
                                activeIndex + 1 === i
              ) {
                return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 2 === i ||
                                activeIndex + 2 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'semi',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (activeIndex + 3 === i) {
                return React.cloneElement(dot, {
                  className: 'small',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              }

              return React.cloneElement(dot, {
                className: 'none',
              });

            });
          }
        } else if (activeIndex <= dots.length - 5) {
          if (this.onCenterLeft === false) {
            activeDots = dots.map((dot, i) => {
              if (dot.props.className === activeDotClassName) {
                return React.cloneElement(dot, {
                  className: 'slick-active large',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex + 1 === i ||
                                activeIndex + 2 === i
              ) {
                return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 1 === i ||
                                activeIndex + 3 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'semi',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 2 === i ||
                                activeIndex + 4 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'small',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              }

              return React.cloneElement(dot, {
                className: 'none',
              });

            });
          } else if (this.onCenterLeft === true) {
            this.onCenterLeft = false;
            activeDots = dots.map((dot, i) => {
              if (dot.props.className === activeDotClassName) {
                return React.cloneElement(dot, {
                  className: 'slick-active large',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 1 === i ||
                                activeIndex + 1 === i
              ) {
                return React.cloneElement(dot, {className: 'large'}, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 2 === i ||
                                activeIndex + 2 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'semi',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              } else if (
                activeIndex - 3 === i ||
                                activeIndex + 3 === i
              ) {
                return React.cloneElement(dot, {
                  className: 'small',
                }, React.cloneElement(dot.props.children, {disabled: true}));
              }

              return React.cloneElement(dot, {
                className: 'none',
              });

            });
          }
        }
      }
    } else {
      // if total dots is less than or equal to 7 just render the dots
      activeDots = [...dots];
    }

    this.previousActiveIndex = activeIndex;

    return (
      <ul className="slick-dots infinite-nav-dots">
        {activeDots}
      </ul>
    );
  }
}

export default ReactNavDots;

ReactNavDots.propTypes = {
  /** Array of <LI /> HTML elements */
  dots: PropTypes.array.isRequired,
  /** className of active slider dot. */
  activeDotClassName: PropTypes.string,
};

ReactNavDots.defaultProps = {
  activeDotClassName: 'slick-active',
};
